import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { menuInterface } from '../../Model/Seguridad/menu.Interface';

@Injectable({
  providedIn: 'root'
})
export class SidemeduFacadeService {

  private Menus$ = new BehaviorSubject<menuInterface[]>([]);
  public responseMenus$: Observable<menuInterface[]> = this.Menus$.asObservable();

  constructor() { }

  consumirMenus() {
    let menus: any[] = [];
    menus = JSON.parse(localStorage.getItem('menus'));
    this.Menus$.next(menus);
  }

  setearMenusFiltrado(item) {
    this.Menus$.next(item);
    localStorage.setItem("menus", JSON.stringify(item));
  }
}
